import React, { useId } from 'react';
import styles from './Input.module.css';

/**
 * Стандартизированный компонент Input с опциональным label.
 * Автоматически связывает label и input через ID.
 */
const Input = ({ label, id, className, type = 'text', wrapperClassName, isInvalid, ...props }) => {
    // Хук useId генерирует уникальный ID, который стабилен между рендерами.
    const autoId = useId();
    // Используем переданный id, если он есть, иначе - сгенерированный.
    const inputId = id || autoId;

    const inputClassName = `${styles.input} ${isInvalid ? styles.invalid : ''} ${className || ''}`.trim();
    const wrapperClass = `${styles.wrapper} ${wrapperClassName || ''}`.trim();

    return (
        <div className={wrapperClass}>
               {label && (
                   <label htmlFor={inputId} className={styles.label}>
                       {label}
                   </label>
               )}
                   <input
                       type={type}
                       id={inputId}
                       className={inputClassName}
                       {...props}
                   />
        </div>
    );
};

export default Input;
